"use client";
import React, { useState, useEffect } from "react";
import { getDiscordStats } from "@/lib/api/discord";
import Image from "next/image";

const DiscordStatsComponent = ({ translations }: { translations: any }) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const stats = await getDiscordStats();
        setData(stats);
        setLoading(false);
      } catch (err) {
        //@ts-ignore
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="mt-2 cursor-default select-none space-y-2 rounded-md border-[0.5px] border-[#3C3C3C] bg-[#2b2d31] p-4 shadow-2xl">
        <p className="text-xs font-semibold uppercase  text-transparent text-white">
          💎 {translations.contestGems} 💎
        </p>
        <div className="flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-16">
          <div className="flex w-full items-center gap-4">
            <div className="mr-auto flex flex-row">
              <Image
                width={500}
                height={500}
                src={"https://cdn6.imgpog.com/discord.webp"}
                alt="Discord"
                className="mr-3 h-14 w-14 rounded-xl"
                draggable="false"
                loading="eager"
                unoptimized
              />
              <div className="mt-0 sm:mt-1">
                <a target="_blank" rel="noopener noreferrer" href="https://discord.gg/createaiart">
                  <h2 className="mb-1 cursor-pointer text-start text-base font-normal text-white hover:underline">
                    🎨 Create AI Art 18+
                  </h2>
                </a>
                <div className="flex flex-col items-center justify-between gap-1.5 text-xs sm:flex-row">
                  <p className="mr-auto whitespace-nowrap text-[#d1d5db]">
                    <span className="mr-1 inline-flex">
                      <svg className="h-[0.6rem] w-[0.6rem] fill-[#23a559]" viewBox="0 0 512 512">
                        <path d="M256 23.05C127.5 23.05 23.05 127.5 23.05 256S127.5 488.9 256 488.9 488.9 384.5 488.9 256 384.5 23.05 256 23.05z"></path>
                      </svg>
                    </span>
                    {loading ? "..." : data?.onlineMembers} {translations.online}
                  </p>
                  <p className="mr-auto whitespace-nowrap text-[#d1d5db]">
                    <span className="mr-1 inline-flex">
                      <svg className="h-[0.6rem] w-[0.6rem] fill-[#4e5058]" viewBox="0 0 512 512">
                        <path d="M256 23.05C127.5 23.05 23.05 127.5 23.05 256S127.5 488.9 256 488.9 488.9 384.5 488.9 256 384.5 23.05 256 23.05z"></path>
                      </svg>
                    </span>
                    {loading ? "..." : data?.totalMembers} {translations.members}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <a
            className="w-full lg:w-auto"
            target="_blank"
            rel="noopener noreferrer"
            href="https://discord.gg/createaiart"
          >
            <button className="focus-visible:ring-ring ring-offset-background inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-md bg-[#248046] px-4 py-2 text-sm font-medium text-[#e9ffec] transition-colors hover:bg-[#1a6334] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
              {translations.join}
            </button>
          </a>
        </div>
      </div>
    </>
  );
};

export default DiscordStatsComponent;
